var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderIconCheckDoneBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 64,
    viewBox: "0 0 66 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.32381 23.3008C9.14905 20.9799 10.985 19.0005 13.3125 19.0005H61.2314C63.7084 19.0005 65.5899 21.2288 65.1749 23.6707L59.5659 56.6707C59.2391 58.5937 57.573 60.0005 55.6225 60.0005H15.7974C13.7048 60.0005 11.9658 58.3876 11.8087 56.3008L9.32381 23.3008Z",
    fill: "#EDF0F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 31L34.25 47L28 39.7273",
    stroke: "#314ACE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.67012 18.5852H5.75886L5.61446 16.9775C5.51703 15.8895 6.31459 15.0005 7.3875 15.0005H22.0774C23.1503 15.0005 24.1073 15.8895 24.2048 16.9775L24.3476 18.5852H52.6259C54.2345 18.5852 55.6701 19.9187 55.8163 21.5501L58.9879 57.0341C59.1341 58.6654 57.9369 60.0005 56.33 60.0005H7.37406C5.76552 60.0005 4.32992 58.6654 4.18386 57.0341L1.01208 21.5501C0.866014 19.9187 2.06158 18.5852 3.67012 18.5852Z",
    stroke: "#4D55E5",
    strokeWidth: 1.5,
    strokeMiterlimit: 2.6131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3848 24.0005H61.3117C62.3624 24.0005 63.1151 25.1768 62.985 26.6162L58.9996 58.0005",
    stroke: "#4D55E5",
    strokeWidth: 1.5,
    strokeMiterlimit: 2.6131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIconCheckDoneBlue);
export default __webpack_public_path__ + "static/media/folder-icon-check-done-blue.78581b3b506fabd072a55aa027c8edb4.svg";
export { ForwardRef as ReactComponent };